import type { IAggregationValue } from '@patsnap/synapse_common_interface'

export const sortLiteratureQuartile = (data: IAggregationValue[]): IAggregationValue[] => {
  return data.slice().sort((a, b) => Number(a.key) - Number(b.key))
}
